import axios from 'axios'
import { toData } from './util'

export function searchCustomers(query): Promise {
  return axios.get(`/api/customers/search?query=${query}`).then(toData)
}

export function getCustomer(id): Promise {
  return axios.get(`/api/customers/${id}`).then(toData)
}
